// This file is auto-generated by dibs-icons script
import { type FC } from 'react';
import Favorite20 from './Favorite20.tsx';
import Favorite20Filled from './Favorite20Filled.tsx';
import Favorite24 from './Favorite24.tsx';
import Favorite24Filled from './Favorite24Filled.tsx';
import Favorite40 from './Favorite40.tsx';
import Favorite40Filled from './Favorite40Filled.tsx';
import Favorite48 from './Favorite48.tsx';
import Favorite48Filled from './Favorite48Filled.tsx';

type FavoriteProps = {
    variation: '20' | '20Filled' | '24' | '24Filled' | '40' | '40Filled' | '48' | '48Filled';
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const svgVariations = {
    Favorite20,
    Favorite20Filled,
    Favorite24,
    Favorite24Filled,
    Favorite40,
    Favorite40Filled,
    Favorite48,
    Favorite48Filled,
};

const Favorite: FC<FavoriteProps> = ({ variation, ...props }) => {
    const variationKey = `Favorite${variation}` as keyof typeof svgVariations;
    const Icon = svgVariations[variationKey];

    if (!Icon) {
        // eslint-disable-next-line no-console
        console.error(`"Favorite" icon variation ${variationKey} does not exist`);
        return null;
    }

    return <Icon {...props} />;
};

export default Favorite;
